import { render, staticRenderFns } from "./PanelSupportDetail.vue?vue&type=template&id=5b5cb418&scoped=true&"
import script from "./PanelSupportDetail.vue?vue&type=script&lang=js&"
export * from "./PanelSupportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5cb418",
  null
  
)

export default component.exports